export default __webpack_public_path__ + "static/media/OrdersNotFound.53fbfd8e.svg";